import React from "react";
import ReactDOM from "react-dom/client";
import "@/monitoring";
import "@/index.css";
import App from "@/App";
import MonitoringBoundary from "@/MonitoringBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MonitoringBoundary>
      <App />
    </MonitoringBoundary>
  </React.StrictMode>,
);
